import styled from 'styled-components';
import { MEDIA_QUERY } from '@sky-distribution/react-commons-ui';
import { icons } from '../../icons';
import { TENANT_NAME, Tenant } from '../../config/tenants';

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${MEDIA_QUERY.below('sm')} {
    height: ${TENANT_NAME === Tenant.TUW ? 'auto' : '64px'};
  }
`;

export const HeaderWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  ${TENANT_NAME === Tenant.TUW ? 'max-width: 768px;' : ''}
`;

export const HeaderLogo = styled(icons[TENANT_NAME].Logo)`
  width: ${TENANT_NAME === Tenant.TUW ? 'clamp(12rem, 40vw, 332px)' : 'clamp(7.2rem, 10vw, 10rem)'};
  max-width: 100%;
  height: auto;
  padding: ${TENANT_NAME === Tenant.TUW ? '0' : '0 1rem'};

  ${MEDIA_QUERY.below('md')} {
    padding: 0;
  }
`;
